import { createStore } from '../_core/createStore';
import { lazyDependency } from '../_core/lazyDependency';
import { Store } from '../_core/types/Store';
import useApiStore from '../apiStore/useApiStore';
import useProgressStore from '../progressStore/useProgressStore';
import useTaskStore from '../taskStore/useTaskStore';
import { dashboardStore } from './dashboardStore';
import { DashboardState } from './types/DashboardState';

const useDashboardStore: Store<DashboardState> = createStore({
  creator: dashboardStore({
    useApiStore: lazyDependency(() => useApiStore),
    useProgressStore: lazyDependency(() => useProgressStore),
    useTaskStore: lazyDependency(() => useTaskStore),
  }),
  id: 'dashboard',
  middlewares: {
    devtools: true,
  },
});

export default useDashboardStore;
